import { useLocation, Link } from "react-router";

export function Header() {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  return (
    <header className="h-12 border-b border-admin-card-border bg-admin-surface px-4 flex items-center">
      <nav className="flex items-center gap-1 text-sm">
        <Link to="/" className="text-admin-text-subtle hover:text-admin-text-primary transition-colors">
          Hjem
        </Link>
        {segments.map((segment, i) => {
          const path = "/" + segments.slice(0, i + 1).join("/");
          const isLast = i === segments.length - 1;
          const label = decodeURIComponent(segment);
          return (
            <span key={path} className="flex items-center gap-1">
              <span className="text-admin-text-subtle">/</span>
              {isLast ? (
                <span className="text-admin-text-primary font-medium">{label}</span>
              ) : (
                <Link to={path} className="text-admin-text-subtle hover:text-admin-text-primary transition-colors">
                  {label}
                </Link>
              )}
            </span>
          );
        })}
      </nav>
    </header>
  );
}
